const el = {
  toastsContainer: document.querySelector('.toasts-container'),
};

export const Toasts = {

  addToast: ({ title = '', text = '', image = '', icon = '' }): void => {
    if (!el.toastsContainer) return

    const toast = document.createElement('button')
    toast.setAttribute('type', 'button')
    toast.classList.add('toast')
    toast.innerHTML = Toasts.getToastHtml({ title, text, image, icon })
    el.toastsContainer.appendChild(toast)

    setTimeout(() => {
      toast.classList.add('toast--visible')
    }, 100);

    setTimeout(() => {
      if (toast) toast.classList.remove('toast--visible')
    }, 4500);

    setTimeout(() => {
      if (toast) toast.remove()
    }, 6000);

    toast.addEventListener('click', () => {
      if (toast) toast.classList.remove('toast--visible')
      setTimeout(() => {
        if (toast) toast.remove()
      }, 300);
    })
  },

  getToastHtml: ({ title = '', text = '', image = '', icon = '' }) => `
    <div class="toast__left">
      ${image && `<img src="${image}" alt="${title}">`}
      ${icon}
    </div>
    <div class="toast__content">
      <h5 class="heading--small text--bold toast__title">${title}</h5>
      <p class="text--small toast__text">${text}</p>
    </div>
    <div class="toast__close">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" fill="#BFBFBF"></path>
      </svg>
    </div>
  `
};
